import { axiosInstance } from "../authService";
import ApiUrlConstant from "../Constants";
const headers = { "Ocp-Apim-Subscription-Key": process.env.REACT_APP_API_KEY }

const DataLibraryServices = {
    getDataLibrary: (params = {}, token) => {
        return axiosInstance.get(ApiUrlConstant.dataLibraryListing(), {
            params, headers: {
                ...headers,
                Authorization: `Bearer ${token}`,
            },
        });
    },
    deleteLibrary: (params = {}, token) => {
        return axiosInstance.delete(ApiUrlConstant.deleteDataLibrary(), {
            params, headers: {
                ...headers,
                Authorization: `Bearer ${token}`,
            },
        })
    },
    addDataLibrary: (payload = {}, token) => {
        return axiosInstance.post(ApiUrlConstant.addDataLibraryListing(), payload, {
            headers: {
                ...headers,
                Authorization: `Bearer ${token}`,
            },
        });
    },
    getDataLibraryById: (params = {}, token) => {
        return axiosInstance.get(ApiUrlConstant.getDataLibraryById(), {
            params, headers: {
                ...headers,
                Authorization: `Bearer ${token}`,
            },
        });
    },
    updateDataLibraryById: (payload = {}, token) => {
        return axiosInstance.put(ApiUrlConstant.updateDataLibraryById(), payload, {
            headers: {
                ...headers,
                Authorization: `Bearer ${token}`,
            },
        });
    }
}

export default DataLibraryServices;